// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__17OMA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1KZiy"};